import { Form, Switch } from "antd";
import React from "react";

const ChangePassword: React.FC = () => {
  return (
    <Form.Item
      name={["managingUser", "systemUser", "forcePasswordChange"]}
      label="Change Password on login?"
    >
      <Switch defaultValue={false} />
    </Form.Item>
  );
};

export default ChangePassword;
